import { render, staticRenderFns } from "./BlogCategoryCreate.vue?vue&type=template&id=47756bde&scoped=true&"
import script from "./BlogCategoryCreate.vue?vue&type=script&lang=js&"
export * from "./BlogCategoryCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47756bde",
  null
  
)

export default component.exports